export default __webpack_public_path__ + "static/media/4.0d2a8809.jpg";